"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpaRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const tpa_entity_1 = require("../../../../service-lib/src/lib/entities/tpa.entity");
const tpa_address_entity_1 = require("../../../../service-lib/src/lib/entities/tpa-address.entity");
const tpa_contact_entity_1 = require("../../../../service-lib/src/lib/entities/tpa-contact.entity");
const address_entity_1 = require("../../../../service-lib/src/lib/entities/address.entity");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_2 = require("../../../../../../libs/service-lib/src/lib/messages");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const constants_2 = require("../../../../service-lib/src/lib/constants");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let TpaRepository = class TpaRepository {
    constructor(tpaRepository, tpaAddressRepository, tpaContactRepository, lookUpRepository, entityService, scopeService) {
        this.tpaRepository = tpaRepository;
        this.tpaAddressRepository = tpaAddressRepository;
        this.tpaContactRepository = tpaContactRepository;
        this.lookUpRepository = lookUpRepository;
        this.entityService = entityService;
        this.scopeService = scopeService;
    }
    /**
     * Creates a new TPA record along with its addresses.
     */
    async addTpa(createTpaObject, userId) {
        const queryRunner = this.tpaRepository.manager.connection.createQueryRunner();
        await queryRunner.connect();
        await queryRunner.startTransaction();
        try {
            const existingTPAByName = await this.findTpaByName(createTpaObject.tpaName);
            if (existingTPAByName) {
                throw new common_1.InternalServerErrorException(`TPA with name ${createTpaObject.tpaName} already exists`);
            }
            const lookup = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_1.TPA_STATUS_ACTIVE },
            });
            if (!lookup) {
                throw new common_1.NotFoundException(`Lookup with key ${constants_1.TPA_STATUS_ACTIVE} not found`);
            }
            const lookupId = lookup?.id;
            const tpaDetails = { ...createTpaObject };
            const tpa = this.tpaRepository.create({
                ...tpaDetails,
                statusLid: lookupId,
                createdBy: userId,
                updatedBy: userId,
            });
            const savedTpa = await this.tpaRepository.save(tpa);
            // Save addresses and map them
            const savedAddresses = [];
            if (createTpaObject.address && createTpaObject.address.length > 0) {
                for (const address of createTpaObject.address) {
                    address.createdBy = userId;
                    address.updatedBy = userId;
                    const savedAddress = await queryRunner.manager.save(address_entity_1.Address, {
                        ...address,
                        countryId: { id: address.countryId },
                        stateId: { id: address.stateId },
                        cityId: { id: address.cityId },
                    });
                    savedAddresses.push(savedAddress);
                    const tpaAddress = this.tpaAddressRepository.create({
                        id: savedTpa.id,
                        addressId: savedAddress.id,
                    });
                    await queryRunner.manager.save(tpaAddress);
                }
            }
            await queryRunner.commitTransaction();
            const tpadata = await this.getTpaById(savedTpa.id);
            // Return the detailed response
            return tpadata;
        }
        catch (error) {
            await queryRunner.rollbackTransaction();
            if (error instanceof Error) {
                throw new common_1.InternalServerErrorException(error.message);
            }
            throw new common_1.InternalServerErrorException("An unknown error occurred");
        }
        finally {
            await queryRunner.release();
        }
    }
    /**
     * Retrieves all TPA records with their addresses
     */
    async getTpas(userId, searchArray, sort = constants_1.DEFAULT_TPA_SORT_FIELD, page = constants_1.TPA_DEFAULT_PAGE, limit = constants_1.TPA_DEFAULT_PAGE_LIMIT, searchBy) {
        const relations = [
            "tpaAddresses", // ← parent
            "tpaAddresses.address", // ← child
            "tpaAddresses.address.cityId",
            "tpaAddresses.address.stateId",
            "status",
            "companyType",
        ];
        const status = await this.lookUpRepository.findOne({
            where: { lookUpKey: constants_1.TPA_STATUS_ACTIVE },
        });
        const whereCondition = {
            statusLid: status?.id ?? undefined,
        };
        // const tpaList = await this.entityService.fetchEntityList(
        //   "Tpa",
        //   page,
        //   limit,
        //   sort.length > 0 ? sort : [{ field: "id", order: "ASC" }],
        //   relations,
        //   whereCondition,
        //   undefined,
        //   searchArray.length === 0 ? [] : searchArray,
        //   undefined,
        //   searchBy,
        //   TpaSearchObject
        // );
        const tpaList = await this.scopeService.validateScope({
            entity: "Tpa",
            page: page,
            limit: limit,
            sort: Array.isArray(sort) && sort.length > 0
                ? sort
                : [{ field: "id", order: "ASC" }],
            relations: relations,
            where: whereCondition,
            select: undefined,
            searchArray: searchArray && searchArray?.length === 0 ? [] : searchArray,
            userFilter: undefined,
            searchString: searchBy,
            searchOn: constants_2.TpaSearchObject,
        }, userId, "Tpa");
        const tpaStatusCount = await this.getTpaCountsByStatus();
        const { data: tpas, count: totalCount } = tpaList;
        const transformedData = tpas.map((tpa) => ({
            id: tpa.id,
            tpaName: tpa.tpaName,
            displayName: tpa.displayName,
            status: tpa.status
                ? {
                    id: tpa.status.id,
                    lookUpValue: tpa.status.lookUpValue,
                }
                : null,
            tpaAddresses: tpa.tpaAddresses?.map((address) => ({
                id: address.id,
                address1: address.address?.address1,
                phoneNumber: address.address?.phoneNumber,
                cityId: address.address?.cityId,
                stateId: address.address?.stateId,
                countryId: address.address?.countryId,
            })),
        }));
        return [transformedData, totalCount, tpaStatusCount.ACTIVE];
    }
    /**
     * Retrieves a TPA record by its ID along with its addresses.
     */
    async getTpaById(id) {
        const tpa = await this.tpaRepository.findOne({
            where: { id: id },
            relations: ["tpaAddresses.address.addressType", "status", "companyType"],
        });
        if (!tpa) {
            throw new common_1.NotFoundException(messages_2.infoMessages.tpaNotFound);
        }
        const tpaData = { ...tpa };
        tpaData.status = tpa.status
            ? {
                id: tpa.status.id,
                lookUpValue: tpa.status.lookUpValue,
            }
            : null;
        tpaData.companyType = tpa.companyType
            ? {
                id: tpa.companyType.id,
                lookUpValue: tpa.companyType.lookUpValue,
            }
            : null;
        const filteredAddresses = tpa.tpaAddresses?.map((address) => {
            const transformedAddress = this.transformAddress(address.address);
            return {
                ...transformedAddress,
            };
        });
        tpaData.tpaAddresses = filteredAddresses ?? [];
        if (tpaData.id === undefined) {
            throw new common_1.InternalServerErrorException("TPA ID is undefined");
        }
        return {
            ...tpaData,
        };
    }
    /**
     * Updates a TPA record by its ID along with its addresses.
     */
    async updateTpaById(id, updateTpaObject, userId) {
        const queryRunner = this.tpaRepository.manager.connection.createQueryRunner();
        await queryRunner.connect();
        await queryRunner.startTransaction();
        try {
            const tpa = await this.tpaRepository.findOne({
                where: { id },
                relations: ["tpaAddresses", "tpaAddresses.address"],
            });
            if (!tpa) {
                throw new common_1.NotFoundException(messages_2.infoMessages.tpaNotFound);
            }
            // Update TPA details
            const { address, ...tpaDetails } = updateTpaObject;
            await this.tpaRepository.update(id, {
                ...tpaDetails,
                updatedBy: userId,
            });
            // Update or add addresses
            const updateAddressList = [];
            if (updateTpaObject.address) {
                const existingAddressIds = await this.getEntityTableMapIds(constants_2.TPA_MAP_TABLE_DELETE_FIELDS.TPA_ADDRESS, constants_2.TPA_MAP_TABLE_DELETE_FIELDS.ADDRESS_ID, { id: id });
                if (updateTpaObject.address.length > 0) {
                    for (const address of updateTpaObject.address) {
                        if (address.id) {
                            // Update existing address
                            const index = existingAddressIds.indexOf(address.id);
                            if (index !== -1) {
                                existingAddressIds.splice(index, 1);
                            }
                            await queryRunner.manager.update(address_entity_1.Address, address.id, {
                                ...address,
                                countryId: { id: address.countryId },
                                stateId: { id: address.stateId },
                                cityId: { id: address.cityId },
                                updatedBy: userId,
                            });
                            updateAddressList.push(address);
                        }
                        else {
                            // Add new address
                            const newAddress = await queryRunner.manager.save(address_entity_1.Address, {
                                ...address,
                                countryId: { id: address.countryId },
                                stateId: { id: address.stateId },
                                cityId: { id: address.cityId },
                                createdBy: userId,
                                updatedBy: userId,
                            });
                            updateAddressList.push(newAddress);
                            // Map new address to TPA
                            const tpaAddress = this.tpaAddressRepository.create({
                                id,
                                addressId: newAddress.id,
                            });
                            await queryRunner.manager.save(tpaAddress);
                        }
                    }
                }
                await this.deleteEntityTableMapIds(constants_2.TPA_MAP_TABLE_DELETE_FIELDS.TPA_ADDRESS, existingAddressIds, constants_2.TPA_MAP_TABLE_DELETE_FIELDS.ADDRESS_ID, constants_1.MAPPED_DATA_DELETION.MAP_REMOVED);
            }
            await queryRunner.commitTransaction();
            return {
                id: id,
            };
        }
        catch (error) {
            await queryRunner.rollbackTransaction();
            if (error instanceof Error) {
                throw new common_1.InternalServerErrorException(error.message);
            }
            throw new common_1.InternalServerErrorException("An unknown error occurred");
        }
        finally {
            await queryRunner.release();
        }
    }
    /**
     * Deletes a TPA record by its ID along with its addresses.
     */
    async deleteTpaById(id) {
        const queryRunner = this.tpaRepository.manager.connection.createQueryRunner();
        await queryRunner.connect();
        await queryRunner.startTransaction();
        try {
            const tpa = await this.tpaRepository.findOne({
                where: { id },
                relations: ["addresses"],
            });
            if (!tpa) {
                throw new common_1.NotFoundException(messages_2.infoMessages.tpaNotFound);
            }
            for (const tpaAddress of tpa.addresses) {
                await queryRunner.manager.softDelete(address_entity_1.Address, tpaAddress.addressId);
            }
            await queryRunner.manager.softDelete(this.tpaAddressRepository.target, {
                id: tpa.id,
            });
            const result = await queryRunner.manager.softDelete(this.tpaRepository.target, id);
            await queryRunner.commitTransaction();
            return (result.affected ?? 0) > 0;
        }
        catch (error) {
            await queryRunner.rollbackTransaction();
            if (error instanceof Error) {
                throw new common_1.InternalServerErrorException(error.message);
            }
            throw new common_1.InternalServerErrorException("An unknown error occurred");
        }
        finally {
            await queryRunner.release();
        }
    }
    /** Add an tpa contact details mapping*/
    async addTpaContact(tpaContactMapData) {
        try {
            const tpaContact = this.tpaContactRepository.create(tpaContactMapData);
            await this.tpaContactRepository.save(tpaContact);
        }
        catch (error) {
            if (error instanceof Error) {
                throw new common_1.InternalServerErrorException(error.message);
            }
            throw new common_1.InternalServerErrorException("An unknown error occurred");
        }
    }
    /** Remove an tpa contact details mapping*/
    async delinkTpaContactMapping(docObject) {
        try {
            await this.tpaContactRepository.delete(docObject);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.tpaContactMappingDeletionFailed || error.message));
        }
    }
    /**
     * Deletes a TPA address by its ID.
     */
    async deleteTpaAddressById(tpaAddressId) {
        const tpaAddress = await this.tpaAddressRepository.findOne({
            where: { tpaAddressId },
        });
        if (!tpaAddress) {
            throw new common_1.NotFoundException(`TPA Address with ID ${tpaAddressId} not found`);
        }
        const result = await this.tpaAddressRepository.softDelete(tpaAddressId);
        return (result.affected ?? 0) > 0;
    }
    // Reusable function to transform an address
    transformAddress(address) {
        return {
            id: address.id,
            address1: address.address1,
            address2: address.address2,
            area: address.area,
            pinCode: address.pinCode,
            email: address.email,
            phoneNumber: address.phoneNumber,
            alternatePhoneNumber: address.alternatePhoneNumber,
            supportNumber: address.supportNumber,
            countryId: address.countryId
                ? {
                    id: address.countryId.id || address.countryId,
                    name: address.countryId.name || null,
                    isoCode: address.countryId.isoCode || null,
                }
                : null,
            stateId: address.stateId
                ? {
                    id: address.stateId.id || address.stateId,
                    name: address.stateId.name || null,
                }
                : null,
            cityId: address.cityId
                ? {
                    id: address.cityId.id,
                    name: address.cityId.name,
                }
                : null,
            addressTypeLid: address.addressTypeLid,
            addressType: address.addressType
                ? {
                    id: address.addressType.id,
                    lookUpValue: address.addressType.lookUpValue,
                }
                : null,
        };
    }
    /**
     * Retrieves the count of TPA records by their status.
     */
    async getTpaCountsByStatus() {
        const queryBuilder = this.tpaRepository
            .createQueryBuilder("tpa")
            .leftJoinAndSelect("tpa.status", "status")
            .select("status.lookUpValueKey", "statusKey")
            .addSelect("COUNT(tpa.id)", "count")
            .groupBy("status.lookUpValueKey");
        const result = await queryBuilder.getRawMany();
        const counts = {};
        result.forEach((row) => {
            counts[row.statusKey] = parseInt(row.count, 10);
        });
        return counts;
    }
    async findTpaByName(tpaName) {
        return await this.tpaRepository.findOne({
            where: {
                tpaName: (0, typeorm_2.ILike)(tpaName),
            },
        });
    }
    /** Create an Tpa Address Data Map */
    async addTpaAddress(tpaAddress) {
        try {
            await this.tpaAddressRepository.save(tpaAddress);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToSaveTpaAddressMapping || error.message));
        }
    }
    /** Finds an Tpa Address Data Map Data */
    async findTpaCompanyAddressMap(id, addressId) {
        return this.tpaAddressRepository.findOne({
            where: {
                tpa: { id: id },
                address: { id: addressId },
            },
        });
    }
    /** Returns active tpa company list data*/
    async CompanyList(page, limit, search, sortBy, sort, userId) {
        try {
            const status = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_1.TPA_STATUS_ACTIVE },
            });
            const [data, count] = await this.tpaRepository.findAndCount({
                where: search
                    ? {
                        statusLid: status?.id ?? undefined,
                        tpaName: (0, typeorm_2.ILike)(`%${search}%`),
                    } // Search by companyName if search is provided
                    : { statusLid: status?.id ?? undefined }, // Fallback if search is empty
                order: {
                    [sortBy]: sort,
                },
                skip: (page - 1) * limit,
                take: limit,
                select: ["id", "tpaName", "displayName"], // Select specific fields
            });
            return {
                data: data,
                count: count,
            };
        }
        catch (error) {
            throw new Error("Failed to fetch tpa company name list");
        }
    }
    /** Returns basic tpa company data such as address and contacts */
    async getCompanyListData(fields, relations, whereCondition) {
        try {
            const entityName = constants_1.DEFAULT_TPA_ENTITY_NAME;
            const data = await this.entityService.getListOfValues(entityName, fields, whereCondition, relations);
            return this.transformResponse(data);
        }
        catch (error) {
            return error;
        }
    }
    /** Transform object for tpa details */
    async transformResponse(data) {
        return {
            id: data?.id,
            tpaName: data?.tpaName,
            displayName: data?.displayName,
            tpaAddresses: (data?.tpaAddresses || []).map((addressData) => ({
                id: addressData?.address?.id,
                address1: addressData?.address?.address1,
                city: {
                    id: addressData?.address?.cityId?.id,
                    name: addressData?.address?.cityId?.name,
                },
            })),
        };
    }
    async getEntityTableMapIds(entity, select, whereCondition) {
        try {
            const data = await this.entityService.getEntityMapByIds(entity, select, whereCondition);
            return data;
        }
        catch (error) {
            return [];
        }
    }
    async deleteEntityTableMapIds(entity, deleteIds, select, deletionType) {
        try {
            await this.entityService.deleteEntityMapByIds(entity, deleteIds, select, deletionType);
        }
        catch (error) {
            throw new common_1.BadRequestException(error);
        }
    }
    /** Fetches TPA contacts by TPA ID. */
    async fetchTpaContacts(tpaId) {
        try {
            const tpaContacts = await this.tpaContactRepository.find({
                where: { tpa: { id: tpaId } },
                relations: ["linkedContact"],
            });
            if (!tpaContacts || tpaContacts.length === 0) {
                return [];
            }
            return tpaContacts.map((tpaContact) => tpaContact.linkedContact);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException(`Failed to fetch contacts for TPA with ID ${tpaId}.`);
        }
    }
};
exports.TpaRepository = TpaRepository;
exports.TpaRepository = TpaRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(tpa_entity_1.Tpa)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(tpa_address_entity_1.TpaAddress)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(tpa_contact_entity_1.TpaContact)),
    tslib_1.__param(3, (0, typeorm_1.InjectRepository)(look_up_entity_1.LookUp)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object, typeof (_d = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _d : Object, typeof (_e = typeof entity_service_utils_1.EntityService !== "undefined" && entity_service_utils_1.EntityService) === "function" ? _e : Object, typeof (_f = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _f : Object])
], TpaRepository);
